import { COLLECTIONS } from "constants/action-types";
import { FluxStandardAction as Action } from "flux-standard-action";

// Match Size Ranges with Selected Sizes
export interface IMatchSelectedSizesWithSizeRangesPayload {
    collectionId: string;
    itemIds: string[];
    filterByBrand: string;
}

export type MatchSelectedSizesWithSizeRangesAction = Action<IMatchSelectedSizesWithSizeRangesPayload, {}>;

export const matchSelectedSizesWithSizeRangesStart = (
    payload: IMatchSelectedSizesWithSizeRangesPayload
): MatchSelectedSizesWithSizeRangesAction => ({
    meta: {},
    payload,
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.MATCH.START,
});

export const matchSelectedSizesWithSizeRangesStop = () => ({
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.MATCH.STOP,
});

export interface IMatchSelectedSizesWithSizeRangesMatchedPayload {
    collectionId: string;
    itemId: string;
    error?: string;
    selectedSizes?: string;
    sizeRange?: ISizeRange;
}

export type MatchSelectedSizesWithSizeRangesMatchedAction = Action<IMatchSelectedSizesWithSizeRangesMatchedPayload, {}>;

export const matchSelectedSizesWithSizeRangesMatched = (
    payload: IMatchSelectedSizesWithSizeRangesMatchedPayload
): MatchSelectedSizesWithSizeRangesMatchedAction => ({
    meta: {},
    payload,
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.MATCH.MATCHED,
});

// Fetch Size Ranges
export interface IFetchSizeRangesPayload {
    merchantId: string;
    itemId: string;
    collectionId: string;
}

export type FetchSizeRangesAction = Action<IFetchSizeRangesPayload, {}>;

export const fetchSizeRanges = (payload: IFetchSizeRangesPayload): FetchSizeRangesAction => ({
    meta: {},
    payload,
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.FETCH.START,
});

export interface ISetSizeRangeLabelPayload {
    sizeRangeLabel: string;
    itemId: string;
}

export type SetSizeRangeLabelAction = Action<ISetSizeRangeLabelPayload, {}>;
export const setSizeRangeLabel = (payload: ISetSizeRangeLabelPayload): SetSizeRangeLabelAction => ({
    meta: {},
    payload,
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.SET_SELECTED_SIZE_RANGE,
});

export const resetSizeRanges = (): Action<{}, {}> => ({
    meta: {},
    payload: {},
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.RESET,
});

export const fetchSizeRangesLoading = () => ({
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.FETCH.LOADING,
});

export interface ISizeRange {
    label: string;
    sizes: string[];
}

export interface ISizeRangesPayload {
    items?: ISizeRange[];
    error?: string;
}

export type FetchSizeRangesCompletedAction = Action<ISizeRangesPayload, {}>;

export const fetchSizeRangesCompleted = (payload: ISizeRangesPayload): FetchSizeRangesCompletedAction => ({
    meta: {},
    payload,
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.FETCH.COMPLETED,
});

export interface IStartSyncSelectedSizesPayload {
    collectionId: string;
    override?: boolean;
}
export type StartSyncSelectedSizesAction = Action<IStartSyncSelectedSizesPayload, {}>;

export const startSyncSelectedSizes = (
    collectionId,
    params?: { override?: boolean }
): StartSyncSelectedSizesAction => ({
    meta: {},
    payload: {
        collectionId,
        override: params?.override,
    },
    type: COLLECTIONS.COLLECTION.SIZING.SYNC_SELECTED_SIZES.START,
});
